module.exports = __webpack_public_path__ + "img/mont-blanc.a8e1c2c9.jpg";